import { render, staticRenderFns } from "./DevicesTerminationStats.vue?vue&type=template&id=05a9e8f0&scoped=true&"
import script from "./DevicesTerminationStats.vue?vue&type=script&lang=js&"
export * from "./DevicesTerminationStats.vue?vue&type=script&lang=js&"
import style0 from "./DevicesTerminationStats.vue?vue&type=style&index=0&id=05a9e8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9e8f0",
  null
  
)

export default component.exports